import { useEffect } from 'react';
import { useErrorBoundary } from 'react-error-boundary';
import { useSearchParams } from 'react-router-dom';

// ?throwTestError=true triggers the boundary on demand.
export const ErrorBoundaryTestTrigger = (): null => {
    const [searchParams] = useSearchParams();
    const { showBoundary } = useErrorBoundary();

    useEffect(() => {
        if (searchParams.get('throwTestError') === 'true') {
            showBoundary(new Error('[ErrorBoundary test] error thrown via ?throwTestError query param'));
        }
    }, [searchParams, showBoundary]);

    return null;
};
